/**
 * VA-28853: when the interviews list should refresh itself.
 *
 * While any interview's report is still being generated, the list re-fetches so
 * the row turns into a verdict without a manual reload. Bounded: a run parked on
 * provider quota can stay "generating" for hours, and an open tab must not poll
 * the full list forever.
 */
export const REPORT_GENERATING_POLL_MS = 30000;
export const REPORT_GENERATING_MAX_POLLS = 120; // one hour at 30s
export const hasReportGenerating = (data) => Array.isArray(data) &&
    data.some((row) => (row === null || row === void 0 ? void 0 : row.report_state) === 'generating');
